import React from 'react'
import PropTypes from 'prop-types'
import { Button, Checkbox, Form, Modal } from 'antd'
import { ConfirmModalGlobalStyle } from './TinTucConfirmSendNotificationModalStyled'

const TinTucConfirmSendNotificationModal =
  propsTinTucConfirmSendNotificationModal => {
    const {
      visible,
      open,
      onConfirm,
      onCancel,
      title = 'Cập nhật tin tức chung',
      message = 'Bạn có muốn cập nhật tin tức chung này không?',
    } = propsTinTucConfirmSendNotificationModal

    const [form] = Form.useForm()

    const isModalVisible = visible !== undefined ? visible : open

    return (
      <>
        <ConfirmModalGlobalStyle />
        <Modal
          wrapClassName="news-confirm-modal-wrapper"
          title={title}
          visible={isModalVisible}
          onCancel={onCancel}
          width={480}
          destroyOnClose
          footer={[
            <Button
              key="cancel"
              type="default"
              className="confirm-btn-cancel"
              onClick={onCancel}>
              Hủy
            </Button>,
            <Button
              key="submit"
              type="primary"
              className="confirm-btn-submit"
              onClick={form.submit}>
              Xác nhận
            </Button>,
          ]}>
          <p className="confirm-modal-text">{message}</p>
          <Form form={form} onFinish={onConfirm}>
            <Form.Item
              name="is_notification_required"
              initialValue={true}
              valuePropName="checked"
              style={{ marginBottom: 0 }}>
              <Checkbox className="confirm-modal-checkbox">
                Gửi thông báo
              </Checkbox>
            </Form.Item>
          </Form>
        </Modal>
      </>
    )
  }

TinTucConfirmSendNotificationModal.propTypes = {
  message: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  visible: PropTypes.bool,
}

export default TinTucConfirmSendNotificationModal
